var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoupanb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3755",
    "data-name": "Rectangle 3755",
    width: 24,
    height: 24,
    transform: "translate(60 479)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3754",
    "data-name": "Rectangle 3754",
    width: 18.01,
    height: 18.009,
    fill: "#9e9e9e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4726",
    "data-name": "Mask Group 4726",
    transform: "translate(-60 -479)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7586",
    "data-name": "Group 7586",
    transform: "translate(62.995 481.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7585",
    "data-name": "Group 7585",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8190",
    "data-name": "Path 8190",
    d: "M18.01,5.981v.528c-.1.3-.182.6-.3.892-.162.4-.344.783-.529,1.167a.987.987,0,0,0,0,.877A10.34,10.34,0,0,1,18.01,11.5v.528a.154.154,0,0,0-.025.044,2.335,2.335,0,0,1-1.632,1.933c-.435.157-.865.326-1.3.486a.9.9,0,0,0-.563.564c-.171.467-.348.932-.524,1.4a2.337,2.337,0,0,1-3.213,1.327c-.437-.2-.876-.391-1.309-.6a.953.953,0,0,0-.876,0Q7.9,17.5,7.211,17.8a2.334,2.334,0,0,1-3.169-1.336c-.177-.465-.353-.93-.524-1.4a.913.913,0,0,0-.574-.575c-.462-.169-.92-.346-1.38-.519A2.335,2.335,0,0,1,.222,10.767c.2-.438.388-.878.6-1.309a.976.976,0,0,0,0-.908C.6,8.1.4,7.647.2,7.19A2.335,2.335,0,0,1,1.536,4.047c.465-.175.929-.355,1.4-.524a.923.923,0,0,0,.587-.585c.18-.495.36-.99.559-1.477A2.293,2.293,0,0,1,5.639.08c.111-.032.226-.054.339-.08h.528c.282.092.571.167.845.279.406.166.806.348,1.2.542a1.007,1.007,0,0,0,.909,0A10.094,10.094,0,0,1,11.5,0h.528a.293.293,0,0,0,.063.027,2.316,2.316,0,0,1,1.889,1.565c.171.448.343.9.505,1.347a.923.923,0,0,0,.586.585c.495.18.99.359,1.476.559a2.286,2.286,0,0,1,1.374,1.544c.034.117.058.236.087.354m-6.245,10.55a.883.883,0,0,0,.788-.576q.27-.7.526-1.4a2.363,2.363,0,0,1,1.491-1.483c.451-.162.9-.333,1.347-.507a.838.838,0,0,0,.495-1.2q-.3-.665-.6-1.327a2.365,2.365,0,0,1,0-2.071q.293-.638.582-1.278a.855.855,0,0,0-.528-1.277c-.466-.175-.933-.345-1.4-.526a2.279,2.279,0,0,1-1.348-1.351c-.179-.464-.35-.931-.526-1.4a.852.852,0,0,0-1.263-.527c-.448.2-.894.409-1.343.608a2.34,2.34,0,0,1-2.006-.02c-.437-.2-.873-.4-1.311-.6a.846.846,0,0,0-1.241.517c-.178.471-.349.944-.532,1.413A2.29,2.29,0,0,1,3.528,4.9c-.475.183-.953.359-1.429.54a.838.838,0,0,0-.5,1.208c.2.443.4.885.6,1.326a2.371,2.371,0,0,1,0,2.071q-.3.662-.6,1.327a.836.836,0,0,0,.5,1.2q.689.262,1.379.52a2.352,2.352,0,0,1,1.452,1.454q.249.675.5,1.348a.844.844,0,0,0,1.229.513c.449-.2.9-.406,1.343-.609a2.317,2.317,0,0,1,1.973-.014c.466.206.926.423,1.392.628a3.455,3.455,0,0,0,.4.122",
    transform: "translate(0)",
    fill: "#9e9e9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8191",
    "data-name": "Path 8191",
    d: "M133.773,112.523a2.166,2.166,0,0,1-.2.438q-2.233,2.994-4.48,5.978a.749.749,0,1,1-1.2-.9q2.238-2.99,4.482-5.976a.736.736,0,0,1,.858-.271.829.829,0,0,1,.534.73",
    transform: "translate(-121.735 -106.495)",
    fill: "#9e9e9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8192",
    "data-name": "Path 8192",
    d: "M111.709,113.248a1.5,1.5,0,1,1,1.494,1.506,1.513,1.513,0,0,1-1.494-1.506",
    transform: "translate(-106.459 -106.497)",
    fill: "#9e9e9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8193",
    "data-name": "Path 8193",
    d: "M207.521,209.061a1.5,1.5,0,1,1,1.494,1.506,1.513,1.513,0,0,1-1.494-1.506",
    transform: "translate(-197.768 -197.807)",
    fill: "#9e9e9e"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupanb);
export default __webpack_public_path__ + "static/media/coupanb.eb75767cc963290ca753b038cc65d433.svg";
export { ForwardRef as ReactComponent };